import { createAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/api";
import { deleteStoredUser, getErrorAsList, getStoredUser, setStoredUser } from "../utils";

const initialState = {
  loading: false,
  error: undefined,
  user: getStoredUser(true),
};

export const clearErrorUser = createAction("users/clearErrorUser");

export const logoutUser = createAction("users/logoutUser");

export const loginUser = createAsyncThunk("users/loginUser", async (args, thunkAPI) => {
  try {
    const body = { email: args.email, password: args.password };
    const { data } = await api.post("/api/users/login/", body);
    return data;
  } catch (error) {
    console.error(error);
    return thunkAPI.rejectWithValue(getErrorAsList(error));
  }
});

export const changePasswordUser = createAsyncThunk("users/changePasswordUser", async (args, thunkAPI) => {
  try {
    const body = {
      new_password: args.newPassword,
      re_new_password: args.reNewPassword,
    };
    const { data } = await api.put(`/api/users/password-change/${args.id}/`, body);
    return data;
  } catch (error) {
    console.error(error);
    return thunkAPI.rejectWithValue(getErrorAsList(error));
  }
});

export const resetPasswordUser = createAsyncThunk("users/resetPasswordUser", async (args, thunkAPI) => {
  try {
    const body = { email: args.email };
    const { data } = await api.post("/api/users/password-reset/", body);
    return data;
  } catch (error) {
    console.error(error);
    return thunkAPI.rejectWithValue(getErrorAsList(error));
  }
});

export const resetPasswordCheckUser = createAsyncThunk("users/resetPasswordCheckUser", async (args, thunkAPI) => {
  try {
    const { data } = await api.get(`/api/users/password-reset-check/${args.uid}/${args.token}/`);
    return data;
  } catch (error) {
    console.error(error);
    return thunkAPI.rejectWithValue(getErrorAsList(error));
  }
});

export const resetPasswordConfirmUser = createAsyncThunk("users/resetPasswordConfirmUser", async (args, thunkAPI) => {
  try {
    const body = {
      new_password: args.newPassword,
      re_new_password: args.reNewPassword,
    };

    const { data } = await api.patch(`/api/users/password-reset-confirm/${args.uid}/${args.token}/`, body);
    return data;
  } catch (error) {
    console.error(error);
    return thunkAPI.rejectWithValue(getErrorAsList(error));
  }
});

export const userSlice = createSlice({
  name: "user",
  initialState,
  extraReducers: {
    // Clear error (if any)
    [clearErrorUser]: (state) => {
      state.error = undefined;
    },

    // Logout
    [logoutUser]: (state) => {
      state.loading = false;
      state.error = undefined;
      state.user = undefined;
      deleteStoredUser();
    },

    // Login
    [loginUser.pending]: (state) => {
      state.loading = true;
    },
    [loginUser.fulfilled]: (state, action) => {
      state.loading = false;
      state.error = undefined;
      state.user = action.payload;
      setStoredUser(state.user);
    },
    [loginUser.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Change password
    [changePasswordUser.pending]: (state) => {
      state.loading = true;
    },
    [changePasswordUser.fulfilled]: (state) => {
      state.loading = false;
      state.error = undefined;
      state.user = { ...state.user, is_first_login: false };
      setStoredUser(state.user);
    },
    [changePasswordUser.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Reset password
    [resetPasswordUser.pending]: (state) => {
      state.loading = true;
    },
    [resetPasswordUser.fulfilled]: (state) => {
      state.loading = false;
      state.error = undefined;
    },
    [resetPasswordUser.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Reset password check
    [resetPasswordCheckUser.pending]: (state) => {
      state.loading = true;
    },
    [resetPasswordCheckUser.fulfilled]: (state) => {
      state.loading = false;
      state.error = undefined;
    },
    [resetPasswordCheckUser.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Reset password confirm
    [resetPasswordConfirmUser.pending]: (state) => {
      state.loading = true;
    },
    [resetPasswordConfirmUser.fulfilled]: (state) => {
      state.loading = false;
      state.error = undefined;
    },
    [resetPasswordConfirmUser.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export default userSlice.reducer;
